import GeniusSiteTracking from "app/components/GeniusTracking/GeniusSiteTracking";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import Modal from "../../../../components/Modal/Modal";
import { SessionHelper } from "../../../../helpers/sessionHelper";
import "./CookieConfirmation.scss";

type Props = {
  onClickAccept: (...args: Array<any>) => any;
  onClickDecline: (...args: Array<any>) => any;
};

const CookieConfirmation: React.FC<Props> = ({
  onClickAccept,
  onClickDecline,
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleAccept = () => {
    onClickAccept();
    SessionHelper.saveAcceptCookieTerms();
  };

  const handleDecline = () => {
    SessionHelper.deleteAcceptCookieTerms();
    window.location.href = "http://www.google.com";
  };

  const handleViewPolicy = () => {
    setModalOpen(true);
  };

  return (
    <div className="cookie-confirmation">
      <div className="cookie-confirmation__message">
        <FormattedMessage tagName="span" id="cookies-message" />
        <span onClick={handleViewPolicy}>
          <FormattedMessage tagName="span" id="cookies-button-view" />
        </span>
      </div>
      <div className="cookie-confirmation__buttons">
        <button id="accept-cookie-button" onClick={handleAccept}>
          <FormattedMessage tagName="span" id="cookies-button-accept" />
        </button>
        <button onClick={handleDecline}>
          <FormattedMessage tagName="span" id="cookies-button-decline" />
        </button>
      </div>
      <Modal
        modalOpen={modalOpen}
        closeModal={closeModal}
        cancelButton
        cancelButtonText="Close"
        contentLabel="Cookie Policy"
        className="cookie-confirmation__modal"
      >
        <div className="cookie-confirmation__modal__message">
          <h3>1. About Cookies</h3>
          <p>
            Cookies are small text files containing information that 3ET, like
            most websites, stores in your browser and can retrieve whilst you
            are browsing the website. This data is used to improve your user
            experience by storing your preferences and helping you make the best
            and most efficient use of our Website.
          </p>

          <h3>2. What Cookies are used for</h3>
          <p>
            Our cookies are not used to store Personal Data, but are used to:
            provide basic functions for your convenience on our Website – e.g.
            keeping you logged on during your session; and enhance the
            functionality of the Website – e.g. remembering your preferences
            like language and build up a profile for a customised browser
            experience for you improve the performance of the Website – e.g.
            testing different design ideas for pages on our Website. Some
            cookies only last until the termination of a session of a given
            browser on the Website, whilst other cookies are persistent, meaning
            that they shall remain on your device until deleted and allow us to
            access personal date from your device.
          </p>

          <h3>3. Disabling Cookies</h3>
          <p>
            When you first visit the Website, you are given the option to either
            provide or not provide your consent to our collecting cookies. If
            you choose not to give us consent to collect cookies we shall not
            collect cookies from you, but you may find that you are not able to
            access certain content on our Website nor may you be able to have
            the most efficient and enjoyable experience on our Website. We
            therefore recommend that you do not prevent us from using cookies
            and accept no liability to you for any losses you may occur as a
            result of disabling cookies.
          </p>

          <p>
            To clear cookies previously placed on your browser, you should
            select the option to clear your browsing history and ensure that the
            option to delete or clear cookies is included when you do so.
          </p>

          <h3>4. Third Party Cookies</h3>
          <p>
            Some cookies on our Website may not be related to 3ET.com. Third
            parties, such as YouTube, often post their content on others’
            websites. Such cookies are not controlled by us and cannot be
            accessed by us. Please inspect the cookie policy of the third party
            for further details. You may also be able to accept or reject some
            or all cookies from third parties by adjusting your browser
            settings.
          </p>

          <h3>5. Further Information</h3>
          <p>
            Further information about cookies is available on
            www.aboutcookies.org and elsewhere on the Internet
          </p>
        </div>
      </Modal>

      <GeniusSiteTracking
        targetSelector="#accept-cookie-button"
        eventType="click"
        pageName="cookie_exclusion"
        value="accept"
      />
    </div>
  );
};

export default CookieConfirmation;
